module.exports = __webpack_public_path__ + "img/user_icn.2242bf27.svg";